module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-depart-form",
    attrs: {
      "width": "850px",
      "title": _vm.title,
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handerClose
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门名称",
      "prop": "deptname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.deptname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deptname", $$v)
      },
      expression: "ruleForm.deptname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门管理员",
      "prop": "deptmanager"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.deptmanager),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deptmanager", $$v)
      },
      expression: "ruleForm.deptmanager"
    }
  }, _vm._l((_vm.allCompanyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门人员",
      "prop": "useridList"
    }
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "姓名 / 账号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getComUser(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getComUser(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "companyRef",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companyList,
      "highlight-current-row": "",
      "height": 500
    },
    on: {
      "selection-change": _vm.handerSectionChange,
      "row-click": _vm.handerRowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "软件类型",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "160",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.deptname || '-'))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce96548"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/DepartManage/ModalForm.vue
// module id = 1724
// module chunks = 9